import { FirebaseComment } from "../../../entities/comment";
import CommentRepository from "../../ports/commentRepository";

export type fetchCommentUsecase = (
  applicantId: string
) => Promise<FirebaseComment>;

export const buildFetchComment = (dependencies: {
  commentRepo: CommentRepository;
}): fetchCommentUsecase => {
  const { commentRepo } = dependencies;

  const fetchComment: fetchCommentUsecase = async (applicantId: string) =>
    commentRepo.fetchComment(applicantId);

  return fetchComment;
};
